export { ClickToPayLogoIllustration } from './components/clickToPayLogo.illustration';
export { ClickToPayLogoNoBrandIllustration } from './components/clickToPayLogoNoBrand.illustration';
